"use client";

import { ApplyButton } from "./applyButton";

export const Hero = () => {
	return (
		<div className="flex flex-col items-center justify-center py-12 px-4 md:py-20">
			<h1 className="text-4xl md:text-6xl font-bold text-center mb-4 font-zenMaru text-suzuka2025white">
				<span className="whitespace-nowrap">高専ビジネス</span>
				<span className="whitespace-nowrap">コンテスト</span>
			</h1>
			<h2 className="text-4xl md:text-6xl font-bold text-center mb-8 font-zenMaru text-suzuka2025white">
				in 鈴鹿高専 2025
			</h2>
			<img src="/events/suzuka2025/div.svg" alt="" className="w-full mb-8" />
			<p className="text-2xl md:text-4xl font-bold text-center mb-16 md:mb-20 font-zenMaru text-suzuka2025white">
				<span className="whitespace-nowrap">テーマ</span>
				<span className="whitespace-nowrap">「持続可能な社会を作る」</span>
			</p>
			<ApplyButton
				googleFormUrl="https://docs.google.com/forms/d/e/1FAIpQLSdk5mPfBTxOuVfCuNW330F4fnsRIhRZBTdMyShvKSOaoIfH6w/viewform"
				className="mb-4"
			/>
			<img
				src="/events/suzuka2025/pc.svg"
				alt=""
				className="w-full max-w-4xl mt-12"
			/>
		</div>
	);
};
